// Top level
const Login = '/auth/login'
const Admin = '/admin'

// Main sections
const Main = `${Admin}/main`

export default {
  Login,
  Main
}



// WEBPACK FOOTER //
// ./src/routes/routesPaths.js